export default __webpack_public_path__ + "static/media/active_traveler.e5ac613e.png";